import { Action, createReducer, on } from '@ngrx/store';
import { GlobalState } from 'src/app/interfaces/store/store.interface';
import { ClearGlobalStateAction, GetOrganisationsAction, GetOrganisationsErrorAction, GetOrganisationsSucessAction, SetEnvironmentAction, SetOrganisationsAction } from './global.actions';
import { initalState } from './global.state';

const reducer = createReducer(
    initalState,
    on(ClearGlobalStateAction, () => ({ ...initalState })),
    on(SetEnvironmentAction, (state: GlobalState, { environment }) => ({
        ...state,
        environment: {
            ...state.environment,
            label: environment.label,
            baseUrl: environment.baseUrl,
        },
    })),
    on(SetOrganisationsAction, (state: GlobalState, { organisations }) => ({
        ...state,
        organisations: {
            data: organisations,
            loading: state.organisations.loading,
        },
    })),
    on(GetOrganisationsAction, (state: GlobalState) => ({
        ...state,
        organisations: {
            data: state.organisations.data,
            loading: true,
        },
    })),
    on(GetOrganisationsSucessAction, (state: GlobalState) => ({
        ...state,
        organisations: {
            data: state.organisations.data,
            loading: false,
        },
    })),
    on(GetOrganisationsErrorAction, (state: GlobalState) => ({
        ...state,
        organisations: {
            data: state.organisations.data,
            loading: false,
        },
    })),
);

export function GlobalReducer(state: GlobalState, action: Action): GlobalState {
    return reducer(state, action);
}
